import React, { useState } from 'react';
import { Button, Card, Typography, Space, Alert, Row, Col } from 'antd';
import { CameraOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import BarcodeScannerModalWrapper from './BarcodeScannerModalWrapper';

const { Title, Text } = Typography;

const CashierBarcodeTest = () => {
  const [scannerVisible, setScannerVisible] = useState(false);
  const [scannedItems, setScannedItems] = useState([]);
  const [total, setTotal] = useState(0);

  // Mock inventory data
  const mockInventory = [
    { name: 'Coca Cola', barcode: '123456789', price: 2.50, category: 'Beverages' },
    { name: 'Pepsi', barcode: '987654321', price: 2.25, category: 'Beverages' },
    { name: 'Chips', barcode: '555666777', price: 3.00, category: 'Snacks' },
    { name: 'Chocolate Bar', barcode: '111222333', price: 1.75, category: 'Candy' },
  ];

  const handleBarcodeScanned = (barcode) => {
    const foundItem = mockInventory.find(item => item.barcode === barcode);
    
    if (foundItem) {
      const existingItem = scannedItems.find(item => item.barcode === barcode);
      
      if (existingItem) {
        // Increase quantity
        setScannedItems(prev => 
          prev.map(item => 
            item.barcode === barcode 
              ? { ...item, quantity: item.quantity + 1 }
              : item
          )
        );
      } else {
        // Add new item
        setScannedItems(prev => [...prev, { ...foundItem, quantity: 1 }]);
      }
      
      // Update total
      setTotal(prev => prev + foundItem.price);
    } else {
      alert(`Item not found with barcode: ${barcode}`);
    }
  };

  const removeItem = (barcode) => {
    const item = scannedItems.find(item => item.barcode === barcode);
    if (item) {
      setScannedItems(prev => prev.filter(item => item.barcode !== barcode));
      setTotal(prev => prev - (item.price * item.quantity));
    }
  };

  const clearCart = () => {
    setScannedItems([]);
    setTotal(0);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <Title level={2}>
        <ShoppingCartOutlined /> Cashier Barcode Test
      </Title>
      
      <Text type="secondary" style={{ display: 'block', marginBottom: '20px' }}>
        Test the barcode scanning functionality in cashier mode. Scan barcodes to add items to cart.
      </Text>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="Scanner Controls" style={{ marginBottom: '16px' }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Button
                type="primary"
                size="large"
                icon={<CameraOutlined />}
                onClick={() => setScannerVisible(true)}
                block
                style={{ height: '50px', fontSize: '16px' }}
              >
                Scan Product Barcode
              </Button>

              <Alert
                message="Test Barcodes"
                description={
                  <div>
                    <div>• 123456789 - Coca Cola ($2.50)</div>
                    <div>• 987654321 - Pepsi ($2.25)</div>
                    <div>• 555666777 - Chips ($3.00)</div>
                    <div>• 111222333 - Chocolate Bar ($1.75)</div>
                  </div>
                }
                type="info"
                showIcon
              />
            </Space>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card 
            title={`Shopping Cart (${scannedItems.length} items)`}
            extra={
              scannedItems.length > 0 && (
                <Button size="small" onClick={clearCart}>
                  Clear Cart
                </Button>
              )
            }
          >
            {scannedItems.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <ShoppingCartOutlined style={{ fontSize: '48px', color: '#ccc' }} />
                <div style={{ marginTop: '16px', color: '#999' }}>
                  Scan barcodes to add items
                </div>
              </div>
            ) : (
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                {scannedItems.map((item, index) => (
                  <div 
                    key={index}
                    style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      padding: '8px',
                      background: '#f5f5f5',
                      borderRadius: '6px'
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{item.name}</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Barcode: {item.barcode} | Qty: {item.quantity}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 'bold' }}>
                        ${(item.price * item.quantity).toFixed(2)}
                      </div>
                      <Button 
                        size="small" 
                        type="text" 
                        danger
                        onClick={() => removeItem(item.barcode)}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                ))}
                
                <div style={{ 
                  borderTop: '2px solid #1890ff', 
                  paddingTop: '12px',
                  marginTop: '12px',
                  textAlign: 'right'
                }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1890ff' }}>
                    Total: ${total.toFixed(2)}
                  </div>
                </div>
              </Space>
            )}
          </Card>
        </Col>
      </Row>

      <BarcodeScannerModalWrapper
        visible={scannerVisible}
        onClose={() => setScannerVisible(false)}
        onScan={handleBarcodeScanned}
        title="Scan Product Barcode"
        allowManualInput={true}
        autoClose={true}
        showResult={false}
        size="medium"
      />
    </div>
  );
};

export default CashierBarcodeTest;

